import MobDetails from './MobDetails';

export default MobDetails;
